import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import useClientViewportType from '@hooks/useClientViewportType'

import Separator from './Separator'

interface MobileOnlySeparatorProps {
  shouldBeHidden?: boolean
}

const StyledMobileOnlySeparator = styled(Separator)`
  ${desktopCSS(css`
    display: none;
  `)};
`
const MobileOnlySeparator: FunctionComponent<MobileOnlySeparatorProps> = ({
  shouldBeHidden,
}) =>
  useClientViewportType() === 'desktop' || shouldBeHidden ? null : (
    <StyledMobileOnlySeparator />
  )

export default MobileOnlySeparator
